var _a;
import { IconCancel } from "@consta/icons/IconCancel";
import { IconCheck } from "@consta/icons/IconCheck";
import { IconInfo } from "@consta/icons/IconInfo";
import { IconWarning } from "@consta/icons/IconWarning";
import { ConstaStatus } from "../../../enums/consta-statuses";
export var IconsMap = (_a = {},
    _a[ConstaStatus.ALERT] = IconCancel,
    _a[ConstaStatus.NORMAL] = IconInfo,
    _a[ConstaStatus.SUCCESS] = IconCheck,
    _a[ConstaStatus.WARNING] = IconWarning,
    _a);
